import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=352c1b4d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=352c1b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c1b4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352c1b4d')) {
      api.createRecord('352c1b4d', component.options)
    } else {
      api.reload('352c1b4d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=352c1b4d&scoped=true&", function () {
      api.rerender('352c1b4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23bhzICVUUZO2/JS/comp/Voucher.vue"
export default component.exports